const calculateTotalIncidents = (incidentRmcs) => {
  let total = 0
  for (let key in incidentRmcs) {
    total += incidentRmcs[key]
  }
  return total
}

export default calculateTotalIncidents
